<template>
    <div class="card-block">
      <div class="form-group row">
        <div class="col-md-10">
          <h5>
            <strong><i class="fas fa-map-marker-alt"></i> Logradouro</strong>
          </h5>
        </div>
        <div class="col-md-2">
          <a v-if="!isBusyLogradouro" href="javascript:void(0);" @click="toggleBusyLogradouro">
            <i class="fas fa-eye" style="font-size: 16px" v-b-tooltip.hover :title="'Minimizar Dados'"></i>
          </a>
          <a v-else href="javascript:void(0);" @click="toggleBusyLogradouro">
            <i class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i>
          </a>
        </div>
      </div>
      <div v-if="!isBusyLogradouro">
        <div v-if="address && address.length > 0">
          <b-tabs content-class="mt-3" pills card>
            <b-tab v-for="(obj, index) in address" :key="index" :title="(index + 1).toString()">
              <div class="form-group row">
                <div class="col-md-12">
                  <label><strong>Endereço</strong></label>
                  <div class="input-group">
                    {{ obj.logradouro }}
                  </div>
                </div>
              </div>

              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Complemento</strong></label>
                  <div class="input-group">
                    {{ obj.complemento }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label><strong>Número</strong></label>
                  <div class="input-group">
                    {{ obj.numero }}
                  </div>
                </div>
              </div>

              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Bairro</strong></label>
                  <div class="input-group">
                    {{ obj.bairro }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label><strong>Cep</strong></label>
                  <div class="input-group">
                    {{ formatCep(obj.cep) }}
                  </div>
                </div>
              </div>

              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Cidade</strong></label>
                  <div class="input-group">
                    {{ obj.municipio }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label><strong>UF</strong></label>
                  <div class="input-group">{{ obj.uf }}</div>
                </div>
              </div>

              <div class="form-group row pt-2">
                <div class="col-md-12">
                  <label><strong>Endereço de correspondência</strong></label>
                  <div class="input-group">
                    {{ obj.endereco }}
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else>
          <div class="form-group row pt-3">
            <div class="col-md-12">
              <label><strong>Endereço</strong></label>
              <div class="input-group"></div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-6">
              <label><strong>Complemento</strong></label>
              <div class="input-group"></div>
            </div>
            <div class="col-md-6">
              <label><strong>Número</strong></label>
              <div class="input-group"></div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-12">
              <label><strong>Bairro</strong></label>
              <div class="input-group"></div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-6">
              <label><strong>Cidade</strong></label>
              <div class="input-group"></div>
            </div>
            <div class="col-md-6">
              <label><strong>UF</strong></label>
              <div class="input-group"></div>
            </div>
          </div>
          <div class="form-group row pt-2">
            <div class="col-md-12">
              <label><strong>Endereço de correspondência</strong></label>
              <div class="input-group"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'AssociateLogradouro',
  props: {
    address: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isBusyLogradouro: true
    }
  },
  methods: {
    formatCep (cep) {
      var re = /^([\d]{5})([\d]{3})/
      if (re.test(cep)) {
        // eslint-disable-next-line no-useless-escape
        return cep.replace(re, '$1-$2')
      } else {
        return 'CEP inválido!'
      }
    },
    toggleBusyLogradouro () {
      this.isBusyLogradouro = !this.isBusyLogradouro
    }
  }
}
</script>

  <style scoped>
  .input-group {
    font-size: 14px;
  }
  .card-block {
    margin: 20px;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateLogradouro.vue